import { backend } from 'api/backend'

/**
 * Gets the company name of the logged in user from backend
 */
export const getCompanyName = () => {
	return backend.get('/portal/companyname')
}
